import { OTA_IDS } from 'frontend-utils/utils/constants/constant-values';
import { COMPARETYPES } from 'lumen/utils/constants/general-constants';

// eslint-disable-next-line max-params
export function generateRatesTableRedirectUrlQueryParams(
  hotelAndMarketService,
  month,
  kpiRefDate = null,
  rateParam = null,
  otaId = null,
  compsetId = null,
) {
  const queryParams = {
    los: hotelAndMarketService.hotelOrMarket.defaultLosRates[0],
    maxPersons: hotelAndMarketService.hotelOrMarket.defaultPersons,
    compsetId: compsetId ?? hotelAndMarketService.activeCompset.apiId,
    otaId: otaId ?? OTA_IDS.BOOKINGDOTCOM,
    view: 'table',
    month,
  };

  if (kpiRefDate) {
    queryParams.compareType = COMPARETYPES.DATE;
    queryParams.compareValue = kpiRefDate;
  }

  if (rateParam) {
    queryParams.rateParam = rateParam;
  }

  return queryParams;
}

// eslint-disable-next-line max-params
export function generateRatesCalendarRedirectUrlQueryParams(
  hotelAndMarketService,
  month,
  rateParam = null,
  otaId = null,
  compsetId = null,
) {
  const queryParams = {
    los: hotelAndMarketService.hotelOrMarket.defaultLosRates[0],
    maxPersons: hotelAndMarketService.hotelOrMarket.defaultPersons,
    compsetId: compsetId ?? hotelAndMarketService.activeCompset.apiId,
    otaId: otaId ?? OTA_IDS.BOOKINGDOTCOM,
    month,
  };

  if (rateParam) {
    queryParams.rateParam = rateParam;
  }

  return queryParams;
}
